import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/contact-status`
const resourceV4 = `${Repository.defaults.baseURL}/v4/contact-status`

export default {
  async list (params) {
    const response = await Repository.get(`${resource}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async detail (id) {
    const response = await Repository.get(`${resource}/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async create (id) {
    const response = await Repository.post(`${resource}`, id, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async update (id, body) {
    const response = await Repository.patch(`${resource}/${id}`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async delete (id) {
    const response = await Repository.delete(`${resource}/${id}`, id, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async countTotalContact (params) {
    const response = await Repository.get(`${resourceV4}/count/contact`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateOrder (id, body) {
    const response = await Repository.patch(`${resource}/order/${id}`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async countTotalContactModule (params) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/v5/contact-status/count/contact`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async contactStatusAddon() {
    const params = {
      obj: 'contact-status-addon',
      attrs: ["id", "contactStatusId", "autoCall"],
      "filters[$eq__autoCall]": 1
    }
    return await Repository.get(`${Repository.defaults.baseURL}/fg/list`, {params});
  }
}
